import { combineReducers } from "redux";
import { registerReducer } from './register'
import { readingModeReducer } from './readingMode'
import { deployStashReducer } from './deployStash'
import { stashLocationReducer } from "./stashLocation";
import { pageStateStashReducer } from "./pageStash";
import { breadcrumbProviderReducer } from "./breadcrumbProvider";


const defaultReducer = () => null;

export default combineReducers({
  register: registerReducer || defaultReducer,
  readingMode: readingModeReducer || defaultReducer,
  deployStash: deployStashReducer || defaultReducer,
  stashLocation: stashLocationReducer || defaultReducer,
  pageStash: pageStateStashReducer || defaultReducer,
  breadcrumbProvider: breadcrumbProviderReducer || defaultReducer,
})

